import HomeIcon from '@mui/icons-material/Home';
import ChatIcon from '@mui/icons-material/Chat';
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import CategoryIcon from '@mui/icons-material/Category';
import InventoryIcon from '@mui/icons-material/Inventory';
import ApartmentIcon from '@mui/icons-material/Apartment';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ReceiptIcon from '@mui/icons-material/Receipt';

// ----------------------------------------------------------------------

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard',
    icon: <HomeIcon />,
    roles: ['Owner', 'Admin', 'Editor', 'Viewer'],
  },
  {
    title: 'companies',
    path: '/companies',
    icon: <BusinessIcon />,
    roles: ['Owner', 'Admin', 'Editor', 'Viewer'],
  },
  {
    title: 'departments',
    path: '/departments',
    icon: <ApartmentIcon />,
    roles: ['Owner', 'Admin', 'Editor', 'Viewer'],
  },
  {
    title: 'locations',
    path: '/locations',
    icon: <LocationOnIcon />,
    roles: ['Owner', 'Admin', 'Editor', 'Viewer'],
  },
  {
    title: 'categories',
    path: '/categories',
    icon: <CategoryIcon />,
    roles: ['Owner', 'Admin', 'Editor', 'Viewer'],
  },
  {
    title: 'people',
    path: '/people',
    icon: <GroupIcon />,
    roles: ['Owner', 'Admin', 'Editor', 'Viewer'],
  },
  {
    isDivider: true,
    roles: ['Owner', 'Admin', 'Editor', 'Viewer'],
  },
  {
    title: 'assets',
    path: '/asset-list',
    icon: <InventoryIcon />,
    roles: ['Owner', 'Admin', 'Editor', 'Viewer'],
  },
  {
    title: 'reporting',
    path: '/reporting',
    icon: <ChatIcon />,
    roles: ['Owner', 'Admin'],
  },
  {
    title: 'user',
    path: '/user',
    icon: <PersonIcon />,
    roles: ['Owner', 'Admin'],
  },
  {
    title: 'billing',
    path: '/billing',
    icon: <ReceiptIcon />,
    roles: ['Owner', 'Admin'],
  },
];

export default navConfig;
